<template>
    <div>
        <loader v-if="pageLoader"></loader>
        <div class="chartStart" v-show="Object.keys(profitChartData).length && profitChartData.series && profitChartData.series.length && profitChartData.series[0].data.length">
        <div  id="leader_profit_chart" class="leaderprofit_chart"></div>
        </div>
        <div class="nodataFound position-relative" v-if="(Object.keys(profitChartData).length && profitChartData.series.length && !profitChartData.series[0].data.length)">
            <div class="boxedNodata">
                <!-- <img class="mb-3" src="../../../../../static/hanko/images/new/nodataLoader.svg" alt="No data" /> -->
                <p class="f-16 bold">{{$t('no_data_found')}}</p>
            </div>
            <!-- <img src="../../../../../static/hanko/images/new/errorGraphLine.png" alt="graph" /> -->
        </div>
    </div>
</template>
<script>
    import { commonAllmixins } from "@/plugins/commonAll";
    // import * as am5 from "@amcharts/amcharts5";
    // import * as am5xy from "@amcharts/amcharts5/xy";
    // import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";
    // import am5themes_Dark from "@amcharts/amcharts5/themes/Dark";
    // import am5themes_Responsive from "@amcharts/amcharts5/themes/Responsive";
    import * as am4core from "../../../../../../node_modules/@amcharts/amcharts4/core"
    import * as am4charts from "../../../../../../node_modules/@amcharts/amcharts4/charts"
    import am4themes_animated from "../../../../../../node_modules/@amcharts/amcharts4/themes/animated"
    export default {
        props: ["leader_detail", "selectedTimefarme"],
        mixins: [commonAllmixins],
        data() {
            return {
                tradingprofitTab: "ROI",
                xAxisColor: "#666666",
                yAxisColor: "#404d7b",
                pageLoader : false
            };
        },
        watch: {
            selectedTimefarme() {
                if (this.selectedTimefarme) {
                    this.destroyChart();
                    this.getProfitChartData();
                }
            },
        },
        methods: {
            getProfitChartData() {
                this._runGetProfitChartData({ globalParams: {}, localParams: { provider_id: this.divide9(this.$route.query.id), type: "TOTAL_PROFIT_ROI", timeframe: this.selectedTimefarme, parameter: this } });
            },
            chartDataProfit() {
                if (Object.keys(this.profitChartData).length && this.profitChartData.series.length && this.profitChartData.series[0].data.length) {
                    if (this.profitChartData.series[0].endDateOfImportedTradeHistory) {
                        const isLargeNumber = (ind) => ind.x > this.profitChartData.series[0].endDateOfImportedTradeHistory;
                        var index = this.profitChartData.series[0].data.findIndex(isLargeNumber);
                        var arrays1 = this.profitChartData.series[0].data.slice(0, index);
                        var arrays2 = [];
                        var finaldat = [];
                        if (arrays1.length) {
                            arrays2 = this.profitChartData.series[0].data.slice(index - 1);
                            finaldat.push({ data: arrays1, name: "Imported history Profit" });
                            finaldat.push({ data: arrays2, name: "Live Profit" });
                        } else {
                            arrays2 = this.profitChartData.series[0].data.slice(index);
                            finaldat.push({ data: this.profitChartData.series[0].data, name: "Live Profit" });
                        }
                        return finaldat;
                    } else {
                        var finalsingle = [];
                        finalsingle.push({ data: this.profitChartData.series[0].data, name: "Live Profit" });
                        return finalsingle;
                    }
                } else {
                    return [];
                }
            },
            destroyChart() {
                let chartElement = am4core.registry.baseSprites.find((sprite) => sprite.htmlContainer.id === "leader_profit_chart");
                if (chartElement) {
                    chartElement.dispose();
                }
            },
            drawprofitChart() {
                // Themes begin
                am4core.useTheme(am4themes_animated);
                // Themes end

                // Create chart instance
                var chart = am4core.create("leader_profit_chart", am4charts.XYChart);
                chart.numberFormatter.numberFormat = "#.##";

                // Create axes
                var dateAxis = chart.xAxes.push(new am4charts.DateAxis());
                dateAxis.renderer.grid.template.location = 0;
                dateAxis.renderer.minGridDistance = 50;
                dateAxis.renderer.grid.template.disabled = true;
                dateAxis.cursorTooltipEnabled = false;
                dateAxis.title.text = 'Date';
                dateAxis.baseInterval = {
                    timeUnit: "day",
                    count: 1
                };

                var valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
                valueAxis.renderer.grid.template.disabled = true;
                valueAxis.cursorTooltipEnabled = false;
                valueAxis.title.text = 'Profit %';
                // Create series
                this.chartDataProfit().forEach((key) => {
                // Add data
                    // chart.data = key.data;
                    var series = chart.series.push(new am4charts.LineSeries());
                    series.dataFields.valueY = "y";
                    series.dataFields.dateX = "x";
                    series.strokeWidth = 2.5;
                    series.fillOpacity = 0.5;
                    series.tooltipText = "[bold]Live Profit(%)[/]: {valueY} \n [bold]Date[/]: {dateX.formatDate('dd MMM yyyy')}";
                    series.tooltip.pointerOrientation = "horizontal";
                    // Add vertical scrollbar
                    // chart.scrollbarY = new am4core.Scrollbar();
                    // chart.scrollbarY.marginLeft = 0;
                    series.tensionX = 0.77;
                    // series.stroke = am4core.color("#5E62B2");
                    // series.fill = am4core.color("#418AFF");
                    series.stroke = am4core.color("#079C77");
                    series.fill = am4core.color("#079C77");
                    series.data = key.data;

                    // ...
                    series.fillOpacity = 0.8;
                    var fillModifier = new am4core.LinearGradientModifier();
                    fillModifier.opacities = [1, 0];
                    fillModifier.offsets = [0, 1];
                    fillModifier.gradient.rotation = 90;
                    series.segments.template.fillModifier = fillModifier;
                })

                // Add cursor
                chart.cursor = new am4charts.XYCursor();
                chart.cursor.behavior = "zoomX";
                chart.cursor.lineX.disabled = true;
                chart.cursor.lineY.disabled = true;
            },
            drawprofitChart1() {
                let _that = this;
                this.destroyChart();

                let root = am5.Root.new("leader_profit_chart");

                let themes = [am5themes_Animated.new(root), am5themes_Responsive.new(root)];
                // if(this.auth_store.mode == 'dark'){
                //     themes.push(am5themes_Dark.new(root));
                // }

                root.setThemes(themes);

                root.dateFormatter.setAll({
                    dateFormat: "dd MMM yyyy",
                    dateFields: ["valueX"],
                });

                root.numberFormatter.setAll({
                    numberFormat: "#.##",
                    //   smallNumberThreshold: 0.001
                });
                // Create drawprofitChart
                var chart = root.container.children.push(
                    am5xy.XYChart.new(root, {
                        focusable: true,
                        paddingRight: 0,
                        paddingLeft: 0,
                    })
                );

                // Create axes
                let xAxis = chart.xAxes.push(
                    am5xy.DateAxis.new(root, {
                        groupData: true,
                        baseInterval: {
                            timeUnit: "day",
                            count: 1,
                        },
                        renderer: am5xy.AxisRendererX.new(root, {
                            minGridDistance: 50,
                        }),
                        startLocation: 1,
                        endLocation: 1,
                        // tooltip: am5.Tooltip.new(root, {})
                    })
                );

                xAxis.get("dateFormats")["day"] = "MM/dd";
                xAxis.get("periodChangeDateFormats")["day"] = "MMMM";

                let yAxis = chart.yAxes.push(
                    am5xy.ValueAxis.new(root, {
                        strictMinMax: true,
                        renderer: am5xy.AxisRendererY.new(root, {}),
                    })
                );
                chart.set("credits", {});
                var label2 = am5.Label.new(root, {
                    text: "[#" + this.xAxisColor + "] Date [/]",
                    x: am5.p50,
                    centerY: am5.p50,
                    fontSize: 12,
                });
                xAxis.children.push(label2);
                xAxis.get("renderer").grid.template.set("forceHidden", true);
                yAxis.get("renderer").grid.template.set("forceHidden", true);
                var label1 = am5.Label.new(root, {
                    rotation: -90,
                    // text: this.tradingProfitTab=='Pips' ?"[#"+this.xAxisColor+"] "+ 'Pips' :"[#"+this.xAxisColor+"] "+ this.leader_detail.trader.stats.profile.baseCurrencyName,
                    text: "[#" + this.xAxisColor + "] Profit %",
                    fill: am5.color(0x666666),
                    y: am5.p50,
                    centerX: am5.p50,
                    fontSize: 12,
                });
                yAxis.children.unshift(label1);
                let yRenderer = yAxis.get("renderer");
                yRenderer.grid.template.setAll({
                    stroke: am5.color(0x666666),
                    strokeWidth: 1,
                });

                //let range = yAxis.createAxisRange(rangeDataItem);
                if (this.chartDataProfit().length > 1) {
                    chart.get("colors").set("colors", [am5.color(0x8dedc8), am5.color(0x404d7b)]);
                } else {
                    chart.get("colors").set("colors", [am5.color(0x404d7b)]);
                }

                var legend = chart.bottomAxesContainer.children.push(
                    am5.Legend.new(root, {
                        x: am5.percent(50),
                        centerX: am5.percent(50),
                        layout: root.horizontalLayout,
                        useDefaultMarker: true,
                        clickTarget: "none",
                        // paddingTop: 15,
                    })
                );

                legend.labels.template.setAll({
                    fontSize: 12,
                    fontWeight: "600",
                });
                legend.markerRectangles.template.setAll({
                    cornerRadiusTL: 20,
                    cornerRadiusTR: 20,
                    cornerRadiusBL: 20,
                    cornerRadiusBR: 20,
                });
                legend.markers.template.setAll({
                    width: 13,
                    height: 13,
                });

                this.chartDataProfit().forEach((key) => {
                    // Add series
                    var series = chart.series.push(
                        am5xy.SmoothedXLineSeries.new(root, {
                            legendLabelText: this.tradingprofitTab == "Pips" ? key.name + " (Pips)" : this.tradingprofitTab == "ROI" ? key.name + " (%)" : key.name + " (" + this.leadersDetail.trader.stats.profile.baseCurrencyName + ")",
                            minBulletDistance: 10,
                            xAxis: xAxis,
                            yAxis: yAxis,
                            valueYField: "y",
                            valueXField: "x",
                            tooltip: am5.Tooltip.new(root, {
                                pointerOrientation: "horizontal",
                                labelText: "{valueY}",
                            }),
                        })
                    );
                    series.fills.template.setAll({
                        visible: true,
                    });

                    series.fills.template.set(
                        "fillGradient",
                        am5.LinearGradient.new(root, {
                            stops: [
                                {
                                    color: am5.color(0x545ad9), // Sky blue
                                    opacity: 0.8,
                                },
                                {
                                    color: am5.color(0x555ce0), // Purple
                                    opacity: 0.3,
                                },
                                {
                                    color: am5.color(0x40b9e2), // Cornflower blue
                                    opacity: 0.1,
                                },
                            ],
                            // stops: [{
                            //     opacity: 0.7
                            // }, {
                            //     opacity: 0.1
                            // }]
                        })
                    );

                    series.strokes.template.setAll({
                        strokeWidth: 2,
                    });

                    // Set data
                    var data = key.data;
                    series.data.setAll(data);
                    legend.data.push(series);

                    // Make stuff animate on load
                    series.appear(1000);
                });

                // Add cursor
                let cursor = chart.set(
                    "cursor",
                    am5xy.XYCursor.new(root, {
                        // xAxis: xAxis,
                        behavior: "zoomX",
                    })
                );
                cursor.lineY.set("visible", false);
                cursor.lineX.set("visible", false);

                xAxis.get("renderer").labels.template.setAll({
                    fill: root.interfaceColors.set("fill", am5.color(this.xAxisColor)),
                    fontSize: 10,
                });
                yAxis.get("renderer").labels.template.setAll({
                    fill: root.interfaceColors.set("fill", am5.color(this.yAxisColor)),
                    fontSize: 12,
                });
                // var label2 = am5.Label.new(root, {
                //     text: "[#666] Date [/]",
                //     x: am5.p50,
                //     centerY: am5.p50,
                //     fontSize: 12,
                // })
                // xAxis.children.push( label2 );
                // var label1 = am5.Label.new(root, {
                //     rotation: -90,
                //     text: this.tradingprofitTab =='Pips' ? 'Profit (Pips)' : (this.tradingprofitTab =='ROI' ? 'Profit (%)' : 'Profit ('+this.leadersDetail.trader.stats.profile.baseCurrencyName+')'),
                //     fill: am5.color(0x666666),
                //     y: am5.p50,
                //     centerX: am5.p50,
                //     fontSize: 12,
                // })
                // yAxis.children.unshift( label1 );

                chart.appear(1000, 100);

                // var previousBulletSprites = [];
                // cursor.events.on("cursormoved", cursorMoved);

                // function cursorMoved() {
                //   for(var i = 0; i < previousBulletSprites.length; i++) {
                //     previousBulletSprites[i].unhover();
                //   }
                //   previousBulletSprites = [];
                //   chart.series.each(function(series) {
                //     var dataItem = series.get("tooltip").dataItem;
                //     if (dataItem && dataItem.bullets) {
                //         var bulletSprite = dataItem.bullets[0].get("sprite");
                //         bulletSprite.hover();
                //         previousBulletSprites.push(bulletSprite);
                //     }
                //   });
                // }
            },
        },
        mounted() {
            this.getProfitChartData();
        },
    };
</script>
<style>
    .leaderprofit_chart {
        height: 290px;
        width: 100%;
    }

    /* .am5-layer-30{
        display: none!important;
    } */
</style>



// WEBPACK FOOTER //
// src/components/website/copy-trade/leader-detail/Charts/Profit-Chart.vue